export default "__VITE_ASSET__Dm74QpvO__"